import { useQuery } from '@tanstack/react-query';
import { surveysQueryKeys } from '../Constants/queryKeys';
import { getSurveys } from '../Services/Surveys.service';
import type { SurveyListRequest } from '../Types/Surveys.types';
import { MAX_LIST_LIMIT } from '@/Shared/constants/listLimits';

/**
 * Every survey, or a filtered set.
 *
 * Asks for the maximum by default, for the same reason as the other listings in this panel: the
 * BFF answers 10 items unless told otherwise, and this screen groups the whole result by BU.
 */
export const useSurveys = (params: SurveyListRequest = {}, enabled = true) =>
  useQuery({
    queryKey: surveysQueryKeys.list(params),
    queryFn: () => getSurveys({ limit: MAX_LIST_LIMIT, ...params }),
    /*
      Off, rather than asking with an empty filter. The exit-questionnaire panel of an opt-in
      feature filters by that feature's id, and a feature being created has none yet — asking
      anyway would fetch every survey of the tenant and then claim they all belong to it.
    */
    enabled,
  });
